import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchNone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 200.63,
			cy: 101.43,
			r: 89.01,
			fill: "var(--primary)",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M128.38 254.8 49.4 206.27v-78.98l78.98 48.52z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M128.38 256.13q-.37 0-.7-.2L48.7 207.41c-.4-.25-.63-.67-.63-1.14V127.3a1.33 1.33 0 0 1 2.02-1.14l78.99 48.53c.4.24.63.67.63 1.13v79a1.33 1.33 0 0 1-1.33 1.32Zm-77.66-50.6 76.34 46.9v-75.87l-76.34-46.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m128.38 175.81-30.59 39.5-78.99-48.53 30.6-39.49z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M97.79 216.64q-.37 0-.7-.2L18.1 167.9a1.33 1.33 0 0 1-.35-1.94l30.6-39.5a1.33 1.33 0 0 1 1.74-.31l78.99 48.52a1.33 1.33 0 0 1 .35 1.95l-30.6 39.49a1.3 1.3 0 0 1-1.04.51Zm-77.03-50.22 76.7 47.13 28.97-37.38-76.71-47.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m128.38 254.8 78.99-48.53v-78.98l-78.99 48.52z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M128.38 256.3q-.38 0-.73-.19a1.5 1.5 0 0 1-.77-1.3v-79c0-.52.27-1 .72-1.27L206.59 126a1.5 1.5 0 0 1 2.28 1.28v78.98c0 .52-.27 1-.71 1.28l-79 48.53a1.5 1.5 0 0 1-.78.22Zm1.5-79.65v75.47l76-46.69v-75.46z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M128.38 80.52v95.29L49.4 127.29z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M128.38 177.14q-.37 0-.7-.2L48.7 128.42a1.33 1.33 0 0 1 .02-2.27l78.99-46.78a1.33 1.33 0 0 1 2 1.15v95.3a1.33 1.33 0 0 1-1.33 1.32m-76.41-49.83 75.09 46.13v-90.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M128.38 80.52 49.4 127.29 18.78 87.05l78.99-47.69z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M49.4 128.61c-.4 0-.8-.18-1.06-.52L17.72 87.85a1.33 1.33 0 0 1 .37-1.94l78.99-47.68c.59-.36 1.34-.2 1.75.34l30.62 41.15a1.32 1.32 0 0 1-.4 1.94l-78.98 46.77q-.32.18-.67.18m-28.67-41.2 29 38.13 76.7-45.42-29.01-39z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m128.37 80.52 78.99 46.77 30.62-40.24-78.99-47.69z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M207.36 128.61q-.35 0-.68-.18L127.7 81.66a1.33 1.33 0 0 1-.4-1.94l30.62-41.15c.41-.55 1.17-.7 1.76-.34l78.98 47.68a1.33 1.33 0 0 1 .37 1.94l-30.61 40.24c-.26.34-.66.53-1.06.53Zm-77.04-48.49 76.7 45.42 29-38.12-76.68-46.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m237.97 166.78-78.99 48.53-30.6-39.5 78.99-48.52z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M158.98 216.64c-.4 0-.8-.18-1.05-.52l-30.6-39.5a1.33 1.33 0 0 1 .36-1.94l78.98-48.52a1.33 1.33 0 0 1 1.75.32l30.6 39.49a1.33 1.33 0 0 1-.36 1.94l-78.99 48.53q-.32.2-.7.2m-28.64-40.47 28.96 37.38 76.7-47.13-28.95-37.38z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m207.37 127.29-78.99 48.52V80.52z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M128.38 177.14a1.33 1.33 0 0 1-1.32-1.33v-95.3a1.33 1.33 0 0 1 2-1.14l78.99 46.77a1.33 1.33 0 0 1 .01 2.28l-78.98 48.52q-.34.2-.7.2m1.33-94.3v90.6l75.09-46.13z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 202.88,
			cy: 153.73,
			r: 58.48,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M203 215q-5.66 0-11.36-1.05c-33.2-6.2-55.18-38.26-48.98-71.46s38.26-55.18 71.46-48.98c16.08 3 30.03 12.09 39.28 25.58s12.7 29.8 9.7 45.88S251 195 237.5 204.26A61 61 0 0 1 203 215m-.15-116.99a55.8 55.8 0 0 0-54.74 45.5 55.77 55.77 0 0 0 44.54 64.98 55.4 55.4 0 0 0 41.72-8.81 55.4 55.4 0 0 0 23.27-35.73A55.77 55.77 0 0 0 202.85 98Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m252.65 231.22-12.62 7.13-15.92-28.2a4.1 4.1 0 0 1 .48-4.76 13.5 13.5 0 0 1 7.78-4.4c1.74-.32 3.5.5 4.36 2.04z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M240.03 239.94c-.56 0-1.1-.3-1.39-.81l-15.91-28.2a5.7 5.7 0 0 1 .67-6.58 15 15 0 0 1 8.7-4.92c2.4-.43 4.81.7 6.01 2.82l15.92 28.2a1.6 1.6 0 0 1-.6 2.16l-12.63 7.12q-.36.2-.77.2Zm-6.92-37.43q-.23 0-.45.04a12 12 0 0 0-6.88 3.89c-.7.8-.83 1.99-.29 2.94l15.14 26.81 9.86-5.57-15.14-26.8a2.6 2.6 0 0 0-2.24-1.31"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m250.63 223.8-15.94 9-1.03-1.82a2.9 2.9 0 0 1 .8-3.77 54 54 0 0 1 11.5-6.5 2.9 2.9 0 0 1 3.65 1.27z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M234.69 234.39c-.56 0-1.1-.3-1.38-.8l-1.03-1.83a4.5 4.5 0 0 1 1.24-5.83 56 56 0 0 1 11.84-6.68 4.5 4.5 0 0 1 5.63 1.95l1.03 1.82a1.6 1.6 0 0 1-.6 2.16l-15.95 9q-.38.2-.78.2m12.38-12.3q-.26-.01-.5.1a52 52 0 0 0-11.17 6.3c-.53.4-.69 1.13-.36 1.71l.25.44 13.19-7.44-.25-.44a1.3 1.3 0 0 0-1.16-.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M282.15 274.73a7.8 7.8 0 0 1 .05 7.58 15 15 0 0 1-4.7 5.2 15 15 0 0 1-9.04 2.48 7.8 7.8 0 0 1-6.48-3.96l-27.71-49.09a4.2 4.2 0 0 1 .97-5.29 45 45 0 0 1 14.12-7.97 4.2 4.2 0 0 1 5.04 1.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m269.12 291.59-.72-.01a9.5 9.5 0 0 1-7.8-4.77l-27.71-49.09a5.8 5.8 0 0 1 1.34-7.29 47 47 0 0 1 14.62-8.25 5.8 5.8 0 0 1 6.93 2.62l27.75 49.15a9.3 9.3 0 0 1 .06 9.12 16 16 0 0 1-5.2 5.75 16.4 16.4 0 0 1-9.27 2.77m-18.38-66.56q-.44 0-.86.15a43 43 0 0 0-13.62 7.69 2.6 2.6 0 0 0-.61 3.3l27.71 49.08a6.3 6.3 0 0 0 5.16 3.16q4.56.17 8.09-2.21a13 13 0 0 0 4.2-4.65 6.2 6.2 0 0 0-.05-6.04s-27.74-49.15-27.74-49.15a2.6 2.6 0 0 0-2.28-1.33"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 200.63,
			cy: 149.67,
			r: 58.48,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M200.76 209.76q-5.56 0-11.15-1.04c-15.77-2.95-29.45-11.86-38.53-25.09s-12.44-29.2-9.5-44.98a60.14 60.14 0 0 1 70.07-48.03 60.14 60.14 0 0 1 48.03 70.07l-1.56-.3 1.56.3a59.7 59.7 0 0 1-25.09 38.53 59.6 59.6 0 0 1-33.83 10.54m-.15-117a57 57 0 0 0-55.91 46.47c-2.79 14.94.4 30.07 9 42.6s21.55 20.98 36.5 23.77a56.5 56.5 0 0 0 42.6-9 56.5 56.5 0 0 0 23.76-36.5 56.96 56.96 0 0 0-55.95-67.33"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 200.63,
			cy: 149.67,
			r: 48.23,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M200.65 199.5q-4.53 0-9.16-.86a49.5 49.5 0 0 1-31.95-20.8c-7.52-10.98-10.32-24.23-7.88-37.31s9.83-24.43 20.8-31.95a49.5 49.5 0 0 1 37.31-7.88 49.87 49.87 0 0 1 39.83 58.11 49.9 49.9 0 0 1-48.95 40.68Zm-.12-96.49c-9.32 0-18.42 2.8-26.27 8.18a46.3 46.3 0 0 0-19.48 29.92 46.3 46.3 0 0 0 7.38 34.93 46.3 46.3 0 0 0 29.91 19.48 46.7 46.7 0 0 0 54.42-37.3 46.7 46.7 0 0 0-45.96-55.21m47.51 55.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M207.41 113.33a36.97 36.97 0 0 1 29.56 43.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m236.97 158.04-.3-.03a1.6 1.6 0 0 1-1.26-1.85 35.4 35.4 0 0 0-28.29-41.27 1.59 1.59 0 0 1 .58-3.12 38.6 38.6 0 0 1 30.83 44.97 1.6 1.6 0 0 1-1.56 1.3m-83.05-77.47-13.63-3.42q1.4-5.39 3.11-9.14a24 24 0 0 1 4.3-6.48 33 33 0 0 1 6.36-5.1q3.13-1.9 5.58-3.72a21 21 0 0 0 4.12-3.97 14 14 0 0 0 2.43-5.17 16 16 0 0 0 .51-6.02 7.6 7.6 0 0 0-1.9-4.21 8.6 8.6 0 0 0-4.32-2.36 9 9 0 0 0-4.55.04 8.7 8.7 0 0 0-4.09 2.58q-1.82 1.96-2.81 5.68l-15.5-3.88q2.22-8.18 6.8-12.75A21 21 0 0 1 151 16.84q6.1-1.24 12.9.45 7.47 1.87 12.14 5.95a19.4 19.4 0 0 1 6.18 10.03q1.5 5.96-.36 13.46a23 23 0 0 1-4.14 8.82 33 33 0 0 1-6.64 6.35q-3.81 2.74-8.27 5.58a17 17 0 0 0-5.75 5.39 28 28 0 0 0-3.15 7.7ZM134.04 95.3a9.4 9.4 0 0 1 3.96-5.8q3-1.95 6.95-.97a8.4 8.4 0 0 1 5.64 4.12 9.3 9.3 0 0 1 .78 6.99 9.2 9.2 0 0 1-3.96 5.7 8.4 8.4 0 0 1-6.93 1.02q-3.95-1-5.66-4.16a9.3 9.3 0 0 1-.77-6.9Z"
		})
	]
});
export default SvgSearchNone;
